import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import AGB from "./pages/AGB";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Team from "./pages/Team";
import Anfrage from "./pages/Anfrage";
import Leistungen from "./pages/Leistungen";
import ServiceDetail from "./pages/ServiceDetail";
import NotFound from "./pages/NotFound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/agb" element={<AGB />} />
    <Route path="/impressum" element={<Impressum />} />
    <Route path="/datenschutz" element={<Datenschutz />} />
    <Route path="/team" element={<Team />} />
    <Route path="/anfrage" element={<Anfrage />} />
    <Route path="/leistungen" element={<Leistungen />} />
    <Route path="/leistungen/:slug" element={<ServiceDetail />} />
    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
